import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Icon } from 'src/common/components/templateDetails/TemplateDetails.styled';
import Grid from '@material-ui/core/Grid';

export const StyledImage = styled.img`
    display: flex;
    align-items: center;
    object-fit: contain;
    cursor: ${(props) => (props.cursor ? props.cursor : 'pointer')};
`;

export const PlusContainer = styled(Grid)`
    color: white;
    padding: 5px 17px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 15px;
    opacity: 1;
`;

export const ProxyIconContainer = styled(Grid)`
    width: 106px;
    background: ${(props) => props.backGroundColor};
    border-radius: 19px;
    margin: 15px 12px 0 0;
    ${media.mobileDevice`
    margin: 3px 13px 0 0;
    width: 98px;
    height: 38px;
    `}
`;

export const ButtonLabel = styled.label`
    display: flex;
    align-items: center;
    height: 27px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 15px;
    color: #ffffff;
    cursor: ${(props) => (props.cursor ? props.cursor : 'pointer')};
    margin-left: 10px;
`;

export const BackTitle = styled(Grid)`
    color: #1010eb;
    font-family: 'AvenirNextWorld Regular';
    cursor: pointer;
    display: flex;
    font-size: '14px';
    ${media.mobileDevice`
    display: none;
    `}
`;

export const BackTitleMob = styled(Grid)`
    color: #1010eb;
    font-family: 'AvenirNextWorld Regular';
    cursor: pointer;
    display: flex;
    font-size: '14px';
    ${media.mobileDevice`
    display: flex;
    `}
`;

export const Container = styled(Grid)`
    margin: 0 0 10px 7px;
    width: 100%;
    display: flex;
    ${media.mobileDevice`
    margin: 0 0 0 19px;
    width: 93% !important;
`}
`;

export const HeaderTextContainer2 = styled(Grid)`
    position: relative;
`;

export const HeaderTextContainer1 = styled(Grid)`
    font-size: 24px;
    font-family: 'AvenirNextWorld Demi';
    color: #140f4b;
    opacity: 1;
    ${media.mobileDevice`
    display: none;
    `}
`;

export const Container1 = styled(Grid)`
    margin-left: -7px;
    ${media.mobileDevice`
    display: none;
    `}
`;

export const Mobile = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    `}
`;

export const Desktop = styled(Grid)`
    ${media.mobileDevice`
    display: none;
    `}
`;

export const User = styled(Grid)`
    color: #130e4a;
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
`;

export const Designation = styled(Grid)`
    color: #140f4b;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
`;

export const SubHeading = styled(Grid)`
    ${media.mobileDevice`
    margin-left: 12px !important;
    `}
`;

export const ContainerGrid1Mob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    `}
`;

export const HeaderTextContainer1Mob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    font-size: 18px;
    margin-left: 11px;
    font-family: 'AvenirNextWorld Demi';
    color: #140F4B;
    opacity: 1;
    `}
`;

export const ContainerGrid1 = styled(Grid)`
    ${media.mobileDevice`
    display: none;
    `}
`;

export const PopupContainer = styled.div`
    display: block;
    width: 100%;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    overscroll-behavior: contain;
    box-sizing: border-box;
`;

export const CloseIcon = styled(Icon)`
    margin: 0 0 0 auto;
    width: 21px;
    height: 20px;
    ${media.smalDevice`
    margin-left: ${(props) => props.ipadMarginLeft};
    width: 20px;
    height: 20px;
    `}
    ${media.mobileDevice`
    margin: 10px 12px 0 0;
    `}
`;
